export const GET_SKILLS_BEGIN = 'GET_SKILLS_BEGIN'
export const GET_SKILLS_SUCCESS = 'GET_SKILLS_SUCCESS'
export const GET_SKILLS_ERROR = 'GET_SKILLS_ERROR'

export const DELETE_SKILL_BEGIN = 'DELETE_SKILL_BEGIN'
export const DELETE_SKILL_SUCCESS = 'DELETE_SKILL_SUCCESS'
export const DELETE_SKILL_ERROR = 'DELETE_SKILL_ERROR'


export const CREATE_SKILL_BEGIN = 'CREATE_SKILL_BEGIN'
export const CREATE_SKILL_SUCCESS = 'CREATE_SKILL_SUCCESS'
export const CREATE_SKILL_ERROR = 'CREATE_SKILL_ERROR'

export const UPDATE_SKILL_BEGIN = 'UPDATE_SKILL_BEGIN'
export const UPDATE_SKILL_SUCCESS = 'UPDATE_SKILL_SUCCESS'
export const UPDATE_SKILL_ERROR = 'UPDATE_SKILL_ERROR'

export const ADD_USER_SKILL_BEGIN = 'ADD_USER_SKILL_BEGIN'
export const ADD_USER_SKILL_SUCCESS = 'ADD_USER_SKILL_SUCCESS'
export const ADD_USER_SKILL_ERROR = 'ADD_USER_SKILL_ERROR'

export const DELETE_USER_SKILL_BEGIN = 'DELETE_USER_SKILL_BEGIN'
export const DELETE_USER_SKILL_SUCCESS = 'DELETE_USER_SKILL_SUCCESS'
export const DELETE_USER_SKILL_ERROR = 'DELETE_USER_SKILL_ERROR'

export const CLEAR_NEW_SKILL_STATE = 'CLEAR_NEW_SKILL_STATE'